import { acuityLevels } from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class PatientDetailICU extends Vue {
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("config", patientNamespace)
  config!: any;

  @Prop(Object)
  data!: Patient;

  numberOfLinesToShow = 2;

  get diagnosisText() {
    const text = _.get(this, "data.body.current.Diagnosis.text");
    if (text) {
      return text.split(/\|+|\r\n+|\n+/);
    } else {
      return [];
    }
  }

  get acuity() {
    const acuityValue = _.get(
      this.data,
      "body.current.AcuityLevel.value",
      null
    );
    if (acuityValue !== null) {
      return acuityLevels[acuityValue];
    }
    return acuityLevels[0];
  }
}
